import { render, staticRenderFns } from "./subscriptions.vue?vue&type=template&id=3226c663&scoped=true"
import script from "./subscriptions.vue?vue&type=script&lang=js"
export * from "./subscriptions.vue?vue&type=script&lang=js"
import style0 from "./subscriptions.vue?vue&type=style&index=0&id=3226c663&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3226c663",
  null
  
)

export default component.exports